import { Action } from '@ngrx/store'
import { Video } from '../models'
import { PaginatedList } from '../libs/infinite-paginator'

export const SET_LECTURE_VIDEOS = '[Video] Set Lecture Videos'
export const SET_VIDEO_LIST = '[Video] Set Video List'
export const SELECT_VIDEO = '[Video] Select'

export class SetVideoList implements Action {
  readonly type = SET_VIDEO_LIST

  constructor(public videoList: PaginatedList<Video>) { }
}

export class SetLectureVideos implements Action {
  readonly type = SET_LECTURE_VIDEOS

  constructor(public lectureId: number, public videos: Video[]) { }
}

export class SelectVideo implements Action {
  readonly type = SELECT_VIDEO

  constructor(public video: Video) { }
}

export type All = SetLectureVideos | SetVideoList | SelectVideo



// WEBPACK FOOTER //
// ./src/actions/video.ts